import isPropValid from '@emotion/is-prop-valid'
import { mobileTextCss, TextProps, textCss } from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

interface WebsiteLanguageSwitcherDropdownUiStylesInterface extends TextProps {
  isOpened: boolean
  maximumQuantity?: number
}
export const WebsiteLanguageSwitcherDropdownUi = styled.div.withConfig({
  shouldForwardProp: isPropValid,
})<WebsiteLanguageSwitcherDropdownUiStylesInterface>`

  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  ${p => `max-height: calc(1.6431em * ${p.maximumQuantity ?? 5} + (21px * ${p.maximumQuantity ?? 5} + 8px));`}
  z-index: 11;
  ${textCss};
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileTextCss}
    `} 
  ${p => p.theme.phone} {
    ${mobileTextCss}
  }  
`
